import { CheckboxGroup as CheckboxGroupNext, Checkbox as CheckboxNext} from "@nextui-org/react";
import { TextNT } from './text';
import { Controller } from "react-hook-form";
import { cn } from "../../lib/utils";

const CheckboxGroup = props => {
  const { name = '', options = [], control = null, ...rest } = props;

  return (
    <>
      {control ? (
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, onBlur, value } }) => (
            <CheckboxGroupNext
              orientation="horizontal"
              value={value}
              onValueChange={onChange}
              classNames={{
                wrapper: 'gap-8'
              }}
              {...rest}
            >
              {options.length > 0 && options.map((option) => (
                <CheckboxNext key={option.value} value={option.value}>
                  <TextNT type='label' className='text-gray-600 text-base ml-2'>
                    {option.label}
                  </TextNT>
                </CheckboxNext>))}
            </CheckboxGroupNext>

          )}
        />
      ) : (
        <CheckboxGroupNext
          orientation="horizontal"
          classNames={{
            wrapper: 'gap-10'
          }}
          {...rest}
        >
          {options.length > 0 && options.map((option) => (<CheckboxNext key={option.value} value={option.value}><TextNT type='label' className='text-gray-600'>{option.label}</TextNT></CheckboxNext>))}
        </CheckboxGroupNext>
      )}
    </>
  );
};

export default CheckboxGroup;
